const _ = require('lodash');

function ProductDetailService(Restangular, decorateAdditionalDetails, anonymousUserIdService, breakpointsService) {
    this._api = Restangular.one('Product');
    this._apiWithHeaders = Restangular.withConfig(function (RestangularConfigurer) {
        RestangularConfigurer.setFullResponse(true);
      }).one('Product');
    this._decorate = decorateAdditionalDetails;
    this._breakpointsService = breakpointsService; 
    this._anonymousUserIdService = anonymousUserIdService;
}

function appendAdditionalDetails(response) {
    this._decorate(response.Products, response);
    return response;
}

function tidyResponse(response) {
    response.parentProduct = _.find(response.Products, { Stockcode: response.PackParentStockCode });
    response.defaultProduct = _.find(response.Products, { Stockcode: response.PackDefaultStockCode });
    if (!response.defaultProduct) {
        response.defaultProduct = _.find(response.Products, { IsAvailable: true })
    }
    if (!response.defaultProduct) {
        response.defaultProduct = response.Products[0]
    }
    if (!response.parentProduct) {
        response.parentProduct = response.defaultProduct
    }
    return response;
}

ProductDetailService.prototype.getProductDetail = function (productStockcode, aisle, category, validateUrl, packDefaultStockCode) {
    /***
    * IF THE SHAPE OF THIS RESPONSE CHANGES THEN THIS HAS TO BE REFLECTED
    * IN THE ROUTES FOR RICHER RELEVANCE
    * ALSO BE AWARE IF THIS CHANGES THEN IT REQUIRES A FULL RETEST
    ***/
    let payload = { aisle, category, validateUrl, packDefaultStockCode };
    payload.sponsoredAdsSessionId = this._anonymousUserIdService.getAnonymousId();
    payload.criteoPageId = this._breakpointsService.isInSmallFormat ? 'viewItem_API_mobile' : 'viewItem_API_desktop';
    
    return this._apiWithHeaders.one(productStockcode).get(payload).then(response => {
        response.data.eventId = response.headers('x-eventid') || '';
        return response.data.plain();
    })
    .then(appendAdditionalDetails.bind(this))
    .then(tidyResponse.bind(this));
};

ProductDetailService.prototype.getGSProductDetail = function (productStockcode, storeNo) {
    return this._api.one(`${productStockcode}/Prices?StoreNo=${storeNo}`).get()
    .then((response) => {
        return response.plain();
    });
};

module.exports = ProductDetailService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/cards/detail/product/detail-product-service.js
 **/